import {FC} from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div<{$height?: string; $width?: string}>`
	border-radius: 50%;
	height: ${({$height}) => $height || "69px"};
	width: ${({$width}) => $width || "64px"};
	position: relative;

	&.circle {
		height: ${({$height}) => $height || "64px"};
		width: ${({$width}) => $width || "64px"};
	}
`;

const Img = styled.img`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
`;

interface IPlayerAvatar {
	src: string;
	altSrc?: string; // If the image is not loaded, then we show the alt image
	width?: string;
	height?: string;
	alt?: string;
	className?: string;
}

export const PlayerAvatar: FC<IPlayerAvatar> = ({
	src,
	width,
	height,
	alt = "",
	altSrc,
	className,
}) => {
	return (
		<Wrapper $width={width} $height={height} className={className}>
			<Img
				src={src}
				onError={({currentTarget}) => {
					// prevents looping
					if (altSrc && !currentTarget.parentElement?.classList.contains("circle")) {
						currentTarget.src = altSrc;
						currentTarget.parentElement?.classList.add("circle");
					}
				}}
				alt={alt}
			/>
		</Wrapper>
	);
};
